import { Component, OnDestroy } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "edp-smartnow-next-billing-widget",
    templateUrl: "./edp-smartnow-next-billing-widget.component.html",
    styleUrls: ["./edp-smartnow-next-billing-widget.component.scss"],
})
export class EdpSmartnowNextBillingWidgetComponent implements OnDestroy {
    unsubscribe$ = new Subject();
    contract: Contract;

    constructor(private readonly store: Store<IAppState>) {
        this.store.pipe(takeUntil(this.unsubscribe$), select(getContract)).subscribe(contract => {
            this.contract = contract;
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
